<template>
  <div>
      <div>
          <img src="@/assets/common/images/banner_01.png">
      </div>
      <ul>
          <li  :class="{ison:nowindex==0}"  @click="switchmenu(0)">
              <img v-if="nowindex==0" src="/static/user/userinfoon.png">
              <img v-else src="/static/user/userinfo.png">
              <span>用户信息</span>
          </li>

          <li  :class="{ison:nowindex==1}" @click="switchmenu(1)">
              <img v-if="nowindex==1" src="/static/user/collectionon.png">
              <img v-else src="/static/user/collection.png">
               <span >我的收藏</span>
          </li>
          
          <li  :class="{ison:nowindex==5}" @click="switchmenu(5)">
              <img v-if="nowindex==5" src="/static/user/relationon.png">
              <img v-else src="/static/user/relation.png">
               <span >绑定账号</span>
          </li>
          
          <li  :class="{ison:nowindex==2}" @click="switchmenu(2)">
               <img v-if="nowindex==2" src="/static/user/logouton.png">
              <img v-else src="/static/user/logout.png">
              <span>退出登录</span>
          </li>
          
          <li  :class="{ison:nowindex==3}" @click="switchmenu(3)">
              <img v-if="nowindex==3" src="/static/user/passwordon.png">
              <img v-else src="/static/user/password.png">
               <span>修改密码</span>
          </li>
          
          <li  :class="{ison:nowindex==4}" @click="switchmenu(4)">
              <img v-if="nowindex==4" src="/static/user/deleteon.png">
              <img v-else src="/static/user/delete.png">
              <span>注销账号</span>
          </li>
      </ul>
  </div>
</template>

<script>
export default {
   data(){
       return {
           menus: [
            {text: '用户信息','img':"/static/user/userinfo.png"},
            {text: '我的收藏','img':"/static/user/collection.png"},
            {text: '退出登录','img':"/static/user/logout.png"},
            {text: '修改密码','img':"/static/user/password.png"},
            {text: '注销账号','img':"/static/user/delete.png"}
           ],
           nowindex:0          
       }
   } ,
   methods:{
       onpic(e){
           this.nowindex=e
       },
       pic(e){
           this.nowindex=0
       },
       switchmenu(val){
           this.nowindex=val
           this.$emit('switchmenu',val);
           //this.$parent.switchmenu(val)
       }
       
   }
  }
</script>

<style scoped>
    ul{
        padding: 0;
        border-radius: 4px;
        overflow: hidden;
        margin-top: 18px;
    }
    li{
        height: 53px;
        line-height: 53px;
        background-color: #fff;
        text-align: center;
        color: #333333;
        cursor:pointer;
        
    }
    li img{
        vertical-align:middle;
        margin-right: 13px;   
    }
    li:hover{
        background-color: #fff;
        color: #2655ae;
        background-color: #cde6fc;
    }
    .ison{
        background-color: #fff;
        color: #2655ae;
        background-color: #cde6fc;
        
    }
    
</style>


// WEBPACK FOOTER //
// src/components/user/UserNav.vue